import useIntersectionObserver from './useIntersectionObserver';

export default useIntersectionObserver;
